import { type Ref } from 'vue';
import { ReserveType } from '@utils/itinerary';
import type HotelPackage from '@itinerary/hotel/HotelPackage';

export function useData() {
    const route = useRoute();
    const bundleModule = useBundleModule();
    const hotelModule = useHotelModule();
    const bundleForm = useBundleForm();
    const hotelForm = useHotelForm();
    const reserveType = computed(() =>
        route.path.includes('tour/residence')
            ? ReserveType.Bundle
            : ReserveType.Hotel
    );
    const packageSelectStore = usePackageSelectStore();
    const { selectedPackages } = classToRefs(packageSelectStore);
    const isBundleReserve = computed(
        () => reserveType.value === ReserveType.Bundle
    );
    const isHotelReserve = computed(
        () => reserveType.value === ReserveType.Hotel
    );
    const currentHotelModule = computed(() => {
        if (isBundleReserve.value) {
            return bundleModule.getHotelModule();
        } else {
            return hotelModule;
        }
    });
    const currentHotelForm = computed(() => {
        if (isBundleReserve.value) {
            return bundleForm.getHotelForm();
        } else {
            return hotelForm;
        }
    });
    const hotelPackage = computed(
        () =>
            (selectedPackages.value[0] as HotelPackage | undefined) ||
            currentHotelModule.value.ssrHotelPackage ||
            currentHotelModule.value.emptyPackage
    );
    const loadingClass = computed(() => ({
        'loading-skeleton': currentHotelModule.value.isLoadingHotelInfo,
    }));
    const title = computed(() => {
        if (isHotelReserve.value) {
            return hotelPackage.value?.title || '';
        } else {
            return `${hotelPackage.value?.title || ''} و هواپیما`;
        }
    });
    return {
        currentHotelModule,
        reserveType: reserveType as Ref<ReserveType.Hotel | ReserveType.Bundle>,
        isBundleReserve,
        isHotelReserve,
        hotelPackage,
        loadingClass,
        title,
        currentHotelForm,
    };
}
